import { render, staticRenderFns } from "./postRepost.vue?vue&type=template&id=4a5defe8&"
import script from "./postRepost.vue?vue&type=script&lang=js&"
export * from "./postRepost.vue?vue&type=script&lang=js&"
import style0 from "./postRepost.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports